export const passTest = () => {

	let questions=[];

	let personality = [
		"Человек – Природа",
		"Человек – Техника",
		"Человек – Знак",
		"Человек – Художественный образ",
		"Человек - Человек",
	];

	let result = [];

	var p_type = new Object();

	let answers = [0, 0, 0, 0, 0];
	let x2_answers = [8, 9, 13, 14, 15, 16, 17, 18, 22, 24];
	
	let answersArr = []; //массив с ответами (порядковый номер, значение, категория)
	let startVal = 1; //порядковый номер ответа 

	function makeObj() {
		//Человек – Природа
		p_type[questions[3]] = 0;
		p_type[questions[6]] = 0;
		p_type[questions[10]] = 0;
		p_type[questions[17]] = 0;
		p_type[questions[24]] = 0;
		p_type[questions[27]] = 0;
	
		// Человек – Техника
		p_type[questions[1]] = 1;
		p_type[questions[8]] = 1;
		p_type[questions[12]] = 1;
		p_type[questions[15]] = 1;
		p_type[questions[20]] = 1;
		p_type[questions[25]] = 1;
	
		//Человек – Знак
		p_type[questions[4]] = 2;
		p_type[questions[7]] = 2;
		p_type[questions[13]] = 2;
		p_type[questions[18]] = 2;
		p_type[questions[21]] = 2;
		p_type[questions[28]] = 2;
	
		//Человек – Художественный образ
		p_type[questions[2]] = 3;
		p_type[questions[9]] = 3;
		p_type[questions[11]] = 3;
		p_type[questions[16]] = 3;
		p_type[questions[23]] = 3;
		p_type[questions[29]] = 3;
	
		// Человек-Человек
		p_type[questions[0]] = 4;
		p_type[questions[5]] = 4;
		p_type[questions[14]] = 4;
		p_type[questions[19]] = 4;
		p_type[questions[22]] = 4;
		p_type[questions[26]] = 4;
	}



	function getQuestion() {

		$.ajax({
			url: '/ajax.php?mid=28&mode=get_questions',
			method: 'GET',
			dataType: 'json',
			contentType:'application/json',

			success: function(data){
				if (data) {
					//console.log('success')
					questions = data.questions
					makeObj()
					startQuiz()
					init()
					//console.log(data)
					//console.log(questions)

				} else {
					//
				}
			},
			error: function(e) {
				console.log(e)
			}
		});
		return false;
	}

	function sendForm () {
		var t = new URLSearchParams(location.search);
		var name = t.get('name');
		var email = t.get('email');
		$.ajax({
			url: '/ajax.php?mid=28&mode=send_result',
			method: 'POST',
			dataType: 'json',
			data: {result: result, name: name, email: email},
			success: function(data){
				if (data) {
					console.log('success')
					//console.log(data)
					showResult();
	
				} else {
					//
				}
			},
			error: function(e) {
				console.log('ошибка ')
				console.log(e)
				console.log(e.responseText)
			}
		});
		return false;
	}
		
	
	function startQuiz(){
		document.getElementById("question").innerHTML =`<p>${questions[0]}</p>`;
		document.getElementById("counterCurrent").innerHTML = 1;
		document.getElementById("counterAll").innerHTML = ` / ${questions.length}`;
	}

	window.addEventListener("load", () => {
		getQuestion();
	});

	function nextQuestion(n=1){
		let q_num = +document.getElementById("counterCurrent").textContent;

		if(n == -1) q_num-=1;

		if (q_num < questions.length) {
			if(n == -1) {//вернуться к предыдущему вопросу
				document.getElementById("question").innerHTML = `<p>${questions[q_num - 1]}</p>`;
				document.getElementById("counterCurrent").innerHTML = q_num;
			} else { //показать следующий вопрос
				document.getElementById("question").innerHTML = `<p>${questions[q_num]}</p>`;
				document.getElementById("counterCurrent").innerHTML = q_num+n; 
			}

		} else {//итог
			//console.log('вопросы закончились')
			profession();
		}
	}

	const showResult = () => {
		const quiz = document.getElementById('quiz');
		const resultMessage = document.createElement('div');
		
		quiz.classList.add('result');
		quiz.innerHTML = '';
		document.querySelector('.title-section p').innerHTML = '';
		resultMessage.classList.add('result-message');
		resultMessage.innerHTML = '<p>Тест успешно пройден.</p><p>Результаты отправлены на указанную почту</p>';

		quiz.append(resultMessage);
	}

	function profession(){

		var max = 4;
		var indexes = [-1];
		
		for (var i = 0; i < answers.length; i++) {
			if (answers[i] > max) {
				max = answers[i];
				indexes.length = 0;
				indexes.push(i);
			} else {
				if (answers[i] === max) {
					indexes.push(i);
				}
			}
		}
		
		if(indexes[0] === -1) {
			//console.log("Вам ничего не подходит!!!")
			result.push({'message':'Вам ничего не подходит!!!'});

		}
		
		for(var i = 0; i < indexes.length; i++){
		
			if (personality[indexes[i]]) {
				//console.log("Вам подходит: " + personality[indexes[i]])
				result.push({'message':`Вам подходит: ${personality[indexes[i]]}`, 'id': indexes[i], 'type': personality[indexes[i]], 'value': answers[personality.indexOf(personality[indexes[i]])]})
			}
			
		}
		
		
		var min = 4;
		var min_indexes = [-1];
		
		for (var i = 0; i < answers.length; i++) {
			if (answers[i] < min) {
				min = answers[i];
				min_indexes.length = 0;
				min_indexes.push(i);
			} else {
				if (answers[i] === min) {
					min_indexes.push(i);
				}
			}		
		}
		
		for(var i = 0; i < min_indexes.length; i++){
		
			if (personality[min_indexes[i]]) {
				//console.log("Вам не подходит: " + personality[min_indexes[i]])
				result.push({'message':`Вам не подходит: ${personality[min_indexes[i]]}`, 'type': personality[min_indexes[i]], 'value': answers[personality.indexOf(personality[min_indexes[i]])]})
			} 
		}

		//console.log(result)
		//console.log(JSON.stringify(result))
		sendForm();
	}

	function init() {

		const e = document.querySelectorAll(".block-right"),
			//answersAll = document.querySelectorAll(".answers__item"),
			btn = document.querySelector(".answers__btn");
			//s = document.querySelector(".block-right");

		//получить выбранный ответ
		const getAnswer = () => {
			const answerVars = document.querySelectorAll('.answers__item');
			let ans = '';
			answerVars.forEach(item => {
				if(item.children[0].checked) {
					ans = item.children[1].textContent;
				}
			})
			return ans;
		}

		function countAnswers() {
			const question = document.getElementById("question").textContent,
			personality_type = p_type[question];

			let ans = getAnswer();

			let point = 1;
			if (x2_answers.includes(questions.indexOf(question))) {
				point *= 2;
			}

			let plus = 1;
			let minus = -1;
			let zero = 0;

			
			let num;

			if (ans == 'согласен(а)') {
				num = plus
				answers[personality_type] += point;
			} else if (ans == 'сомневаюсь') {
				num = zero;
				answers[personality_type] += 0;
			} else {
				num = minus;
				answers[personality_type] += point * -1;
			}

			//answers+=num;
			answersArr.push({'id': startVal,'n': num, 'type': personality_type})
			startVal++;

			console.log(answers);
			//console.log(answers[personality_type])
			//console.log('pers_type ' + personality_type)
			//console.log(question)
			//console.log(answersArr)

			nextQuestion();
		}

		const returnBack = () => {
			const btnReturn = document.getElementById('btnReturn');
			btnReturn.addEventListener('click', () => {
				if(document.getElementById("counterCurrent").innerHTML == 1) return;
				nextQuestion(-1);

				//console.log('returnBack')
				let v = answersArr[answersArr.length-1]['type'] //номер типа последнего элемента в массиве
				let n = answersArr[answersArr.length-1]['n'] //ответ в  последнем элементе в массиве
				answers[v] -= n;
				//console.log(answers[v])
				//console.log(answers)

				answersArr.pop();
				startVal--;
				//console.log(answersArr)
			})
		}
		returnBack();
		btn.addEventListener('click', countAnswers);
	}
}
